import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import TeacherListPopup from './TeacherListPopup';
import './styles/ScheduleReportPage.css';
import { BsFiles } from "react-icons/bs";

const DAYS = ['SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU'];
const TIMES = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];

const ScheduleReportPage = () => {
    const [scheduleData, setScheduleData] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedTeacher, setSelectedTeacher] = useState(null);
    const [sessionType, setSessionType] = useState('');
    const [selectedDay, setSelectedDay] = useState('');
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [showTeacherPopup, setShowTeacherPopup] = useState(false);

    useEffect(() => {
        api.get('/utils/getBranchList')
            .then(res => {
                const branches = res.data.data.branchList.map(branch => ({
                id: branch.branch_id,
                name: `${branch.branch_code} - ${branch.branch_name}`
                }));
                setBranchList(branches);
            })
            .catch(err => console.error('Failed to fetch branch list', err));
    }, []);

    const handleSearch = () => {
        const body = {
            teacher_id: selectedTeacher?.teacher_id,
            student_id: selectedStudent?.student_id,
            branch_id: selectedBranch,
            day_of_week: selectedDay,
            session_type: sessionType
        };
        api.post('/schedule/report', body)
            .then(res => setScheduleData(res.data.data))
            .catch(err => console.error(err));
    };
    
    const handleReset = () => {
        setSelectedStudent(null);
        setSelectedTeacher(null);
        setSelectedDay('');
        setSessionType('');
        setSelectedBranch('');
        setScheduleData([]);
    };

    const groupedByBranch = {};
    scheduleData.forEach(item => {
        const branch = item.branch;
        const time = item.time.slice(0, 5);
        if (!groupedByBranch[branch]) groupedByBranch[branch] = {};
        if (!groupedByBranch[branch][time]) groupedByBranch[branch][time] = [];
        groupedByBranch[branch][time].push(item);
    });

    
    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Schedule Report</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label>Student</label></td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" readOnly value={selectedStudent?.student_name || ''} />
                                            <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Teacher</label></td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" readOnly value={selectedTeacher?.teacher_name || ''} />
                                            <BsFiles className="icon" onClick={() => setShowTeacherPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Cabang</label></td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                            disabled={selectedStudent || selectedTeacher}
                                        >
                                        <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>{branch.name}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Session Type</label></td>
                                    <td>
                                        <select value={sessionType} onChange={(e) => setSessionType(e.target.value)}>
                                            <option value="">All</option>
                                            <option value="REGULAR">REGULAR</option>
                                            <option value="ENGLISH_CLUB">ENGLISH_CLUB</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Day</label></td>
                                    <td>
                                        <select value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}>
                                            <option value="">All</option>
                                            {DAYS.map(day => <option key={day} value={day}>{day}</option>)}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <button onClick={handleSearch}>Search</button>
                                        <button onClick={handleReset} className="schedule-report-reset-btn">Reset</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {scheduleData.length > 0 &&
                <div className="section">
                    {Object.entries(groupedByBranch).map(([branch, branchData]) => (
                        <div key={branch}>
                            <h3>{branch}</h3>
                            {TIMES.map(time => {
                                const slotData = branchData[time] || [];
                                const teachersAtTime = slotData.map(s => s.teacher);
                                const uniqueTeachers = [...new Set(teachersAtTime)];
                                return (
                                    <div key={time} className="schedule-report-slot-session">
                                        <table className="schedule-report-slot-table">
                                            <thead>
                                                <tr>
                                                    <th>Time</th>
                                                    <th>Teacher</th>
                                                    {DAYS.map(day => <th key={day}>{day}</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {uniqueTeachers.map((teacher, idx) => (
                                                    <tr key={`${teacher}_${time}`}>     
                                                        {idx === 0 && (
                                                            <td rowSpan={uniqueTeachers.length}>
                                                            <strong>{time} - {getEndTime(time)}</strong>
                                                            </td>
                                                        )}
                                                        <td>{teacher}</td>
                                                        {DAYS.map(day => {
                                                            const matches = slotData.filter(s =>
                                                                s.teacher === teacher &&
                                                                s.day === day
                                                            );
                                                            return (
                                                                <td key={day}>
                                                                    {matches.length > 0
                                                                        ? matches.map((m, i) => <div key={i}>{m.student}</div>)
                                                                        : '-'}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
                }
            </div>
    
            {showStudentPopup && (
                <StudentListPopup
                branchId={selectedBranch}
                onSelectStudent={(s) => {
                    setSelectedStudent(s);
                    setSelectedBranch(s.branch_id);
                    setShowStudentPopup(false);
                }}
                onClose={() => setShowStudentPopup(false)}
                />
            )}
    
            {showTeacherPopup && (
                <TeacherListPopup
                branchId={selectedBranch}
                onSelectTeacher={(t) => {
                    setSelectedTeacher(t);
                    setSelectedBranch(t.branch_id);
                    setShowTeacherPopup(false);
                }}
                onClose={() => setShowTeacherPopup(false)}
                />
            )}
        </div>
    );
};

const getEndTime = (start) => {
    const [h, m] = start.split(':').map(Number);
    const endH = h;
    const endM = m + 45;
    return `${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`;
};
  
export default ScheduleReportPage;
  